// Centralized Feed The Farm avatar-animal mappings and helpers.
import { gameLibrary } from '../gameLibrary';
import { PLAYABLE_PLAYER_COLOR_FAMILIES } from '../colors/playerColors';
export const ANIMAL_AVATAR_DEFINITIONS = [
    {
        playerColorKey: 'red',
        animalName: 'Pig',
        assetPrefix: 'Pig',
        soundEffectId: 'animal_pig_oink',
    },
    {
        playerColorKey: 'orange',
        animalName: 'Cow',
        assetPrefix: 'Cow',
        soundEffectId: 'animal_cow_moo',
    },
    {
        playerColorKey: 'amber',
        animalName: 'Sheep',
        assetPrefix: 'Sheep',
        soundEffectId: 'animal_sheep_baa',
    },
    {
        playerColorKey: 'yellow',
        animalName: 'Goat',
        assetPrefix: 'Goat',
        soundEffectId: 'animal_goat_bleat',
    },
    {
        playerColorKey: 'green',
        animalName: 'Horse',
        assetPrefix: 'Horse',
        soundEffectId: 'animal_horse_neigh',
    },
    {
        playerColorKey: 'emerald',
        animalName: 'Donkey',
        assetPrefix: 'Donkey',
        soundEffectId: 'animal_donkey_bray',
    },
    {
        playerColorKey: 'teal',
        animalName: 'Chicken',
        assetPrefix: 'Chicken',
        soundEffectId: 'animal_chicken_cluck',
    },
    {
        playerColorKey: 'cyan',
        animalName: 'Duck',
        assetPrefix: 'Duck',
        soundEffectId: 'animal_duck_quack',
    },
    {
        playerColorKey: 'sky',
        animalName: 'Owl',
        assetPrefix: 'Owl',
        soundEffectId: 'animal_owl_hoot',
    },
    {
        playerColorKey: 'blue',
        animalName: 'Turkey',
        assetPrefix: 'Turkey',
        soundEffectId: 'animal_turkey_gobble',
    },
    {
        playerColorKey: 'indigo',
        animalName: 'Dog',
        assetPrefix: 'Dog',
        soundEffectId: 'animal_dog_bark',
    },
    {
        playerColorKey: 'violet',
        animalName: 'Cat',
        assetPrefix: 'Cat',
        soundEffectId: 'animal_cat_meow',
    },
    {
        playerColorKey: 'purple',
        animalName: 'Mouse',
        assetPrefix: 'Mouse',
        soundEffectId: 'animal_mouse_squeak',
    },
    {
        playerColorKey: 'fuchsia',
        animalName: 'Rabbit',
        assetPrefix: 'Rabbit',
        soundEffectId: 'rabbit_crunching',
    },
    {
        playerColorKey: 'pink',
        animalName: 'Giraffe',
        assetPrefix: 'Giraffe',
        soundEffectId: 'whistle_slide',
    },
    {
        playerColorKey: 'rose',
        animalName: 'Llama',
        assetPrefix: 'Llama',
        soundEffectId: 'animal_llama_ack',
    },
];
if (ANIMAL_AVATAR_DEFINITIONS.length !== PLAYABLE_PLAYER_COLOR_FAMILIES.length) {
    throw new Error('ANIMAL_AVATAR_DEFINITIONS length must match playable families');
}
const animalAvatarDefinitionByPlayerColorKey = Object.fromEntries(ANIMAL_AVATAR_DEFINITIONS.map((definition) => [
    definition.playerColorKey,
    definition,
]));
const feedTheFarmGameId = gameLibrary.find((game) => game.gameCore.gameName === 'Feed The Farm')?.gameCore.gameId;
export const ANIMAL_STYLE_GAME_IDS = feedTheFarmGameId
    ? [feedTheFarmGameId]
    : [];
export function getAnimalAvatarDefinitionForPlayerColorKey(playerColorKey) {
    return (animalAvatarDefinitionByPlayerColorKey[playerColorKey] ?? null);
}
export function getAnimalNameForPlayerColorKey(playerColorKey) {
    return (getAnimalAvatarDefinitionForPlayerColorKey(playerColorKey)?.animalName ??
        null);
}
export function getAnimalAssetPrefixForPlayerColorKey(playerColorKey) {
    return (getAnimalAvatarDefinitionForPlayerColorKey(playerColorKey)?.assetPrefix ??
        null);
}
export function getAnimalSoundEffectIdForPlayerColorKey(playerColorKey) {
    return (getAnimalAvatarDefinitionForPlayerColorKey(playerColorKey)?.soundEffectId ??
        null);
}
export function isAnimalStyleAvatarGame(gameId) {
    return !!gameId && ANIMAL_STYLE_GAME_IDS.includes(gameId);
}
//# sourceMappingURL=animals.js.map